import { api_GET, api_POST, api_PUT, api_DELETE } from "./_api.js";

const volumetria_api = {

    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Volumetria/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetListByModalidade: (modalidadeId) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Volumetria/GetListByModalidade/${modalidadeId}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Volumetria/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Volumetria", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Volumetria", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    }
}

export default volumetria_api;